import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './admin-navigation.scss';

export const AdminNavigation: React.FC = () => {
  const { userRole, logout } = useAuth();

  if (userRole?.role !== 'admin') {
    return null;
  }

  return (
    <div className="admin-navigation">
      <div className="nav-links">
        <NavLink to="/admin" end className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Admin Dashboard
        </NavLink>
        <NavLink to="/admin/reports" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Reports
        </NavLink>
        <NavLink to="/jarvis" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Technician View
        </NavLink>
      </div>
      <div className="user-info">
        <span>Welcome, {userRole.email}</span>
        <button onClick={logout} className="logout-btn">Logout</button>
      </div>
    </div>
  );
}; 